import React, { useState, useMemo } from 'react';
import {
  Paper,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Switch,
  Tooltip,
  Button,
  Grid
} from '@material-ui/core';
import { DataGrid } from '@mui/x-data-grid';
import EditIcon from '@material-ui/icons/Edit';
import { green, red } from '@material-ui/core/colors';
import EditProductDialog from './EditProductDialog';
import { Cancel, CheckCircle } from '@material-ui/icons';

const ProductManager = ({ siteData, refetch }) => {
  const s3_product_url = 'https://d6-halo.s3.amazonaws.com/static/media/products/';
  const staticCategories = siteData?.categories || [];

  const products = useMemo(() =>
    staticCategories.flatMap(cat =>
      cat.products?.map((prod) => ({
        id: prod.id,
        name: prod.name || '',
        description: prod.description || '',
        whatsapp: prod.whatsapp || '',
        share: prod.share || '',
        origPrice: prod.origPrice || '',
        price: prod.price || '',
        image: prod.imageN || null,
        additionalInfo:prod.additionalInfo||'',
        imagePreview: prod.imageN ? s3_product_url + prod.imageN : null,
        category: cat.id,
        categoryName: cat.name,
        priority:prod.priority||1,
        active: prod.active ?? true
      }))
    ).sort((a,b)=>a.id>b.id?1:-1), [staticCategories]);

  const [search, setSearch] = useState('');
  const [selectedProduct, setSelectedProduct] = useState(null);
const [open,setOpen]=useState(false)
  const filteredProducts = products.map((val,idx)=>
  ({


      ...val,
      sno:idx+1
    
  }
  )
  ).filter(p => {
    const searchLower = search.toLowerCase();
    return (
      p.name.toLowerCase().includes(searchLower) ||
      p.categoryName.toLowerCase().includes(searchLower) ||
      p.price.toString().includes(searchLower) ||
      p.origPrice.toString().includes(searchLower)
    );
  });

  const columns = [
        { field: 'sno', headerName: ' S.no ', width: 80 },

    { field: 'name', headerName: 'Name', width: 190 },
    { field: 'categoryName', headerName: 'Category', width: 150 },
    { field: 'origPrice', headerName: 'Original Price', width: 130 },
    { field: 'price', headerName: 'Discount Price', width: 130 },
   
       { field: 'priority', headerName: 'Priority', width: 130 },

    {
  field: 'active',
  headerName: 'Status',
  width: 100,
  renderCell: (params) =>
    params.value ? (
      <CheckCircle style={{color:'green'}} />
    ) : (
      <Cancel style={{color:'red'}} />
    ),
},
    {
      field: 'edit',
      headerName: ' ',
      width: 180,
      sortable: false,
      renderCell: (params) => (


    
            <Button onClick={() => {setSelectedProduct(params.row)

              setOpen(true)
            }}  color={'primary'} variant={'contained'}>Edit Product</Button>
      
      ),
    },
  ];

  return (
    <Paper style={{ padding: 20,width:'100%' }}>
     
     <Grid style={{padding:'1vh 10px'}} container>

  <Grid item style={{textAlign:'-webkit-right'}} sm={12} xs={12}>
                <Button onClick={() => setOpen(true)}  color={'primary'} variant={'contained'}>Add New Product</Button>

  </Grid>
</Grid>
      <TextField
        fullWidth
        label="Search by name, category or price"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{ marginBottom: 16 }}
      />


      <div style={{ height: 500, width: '100%' }}>
        <DataGrid rows={filteredProducts} columns={columns} pageSize={10} />
      </div>

      <EditProductDialog
        open={open}
        onClose={() =>{ setSelectedProduct(null)

          setOpen(false)
        }}
        product={selectedProduct}
        categories={staticCategories}
        refetch={refetch}
      />
    </Paper>
  );
};

export default ProductManager;
